import { messages } from './messages';
import { attributes } from './attributes';
var locale = {
  name: 'en',
  messages: messages,
  attributes: attributes
};
export default locale;